<template>
  <div class="order-cancel">
    <div class="notice">
      <van-image
        class="notice-icon"
        :src="require('../../../assets/cs-pic.png')"
      />
      <div class="notice-text">您正在进行取消订单操作</div>
    </div>
    <div class="reminder">
      <img src="@/assets/images/ld.png" alt="" />
      <b>温馨提示</b>
    </div>
    <div class="order-explain">
      <div>
        <span>订单近在待机构确认订单和待企业确认合同金额时可取消</span>
      </div>
      <div>
        <span>订单取消后不可撤回</span>
      </div>
      <div>
        <span>若遇到问题可随时和服务机构或丽水市中小企业中心进行沟通</span>
      </div>
    </div>
    <div class="list">
      <div class="list-title">{{ goodsName }}</div>
      <div class="list-main">
        <div class="list-main-imgwrap">
          <van-image class="list-main-imgwrap-img" fit="cover" :src="img" />
          <div class="list-main-imgwrap-tab" v-if="iscoupons == 1">券</div>
        </div>
        <div class="list-main-info">
          <div class="list-main-info-price">
            {{ price ? '￥' : '' }}<span>{{ price ? price : '面议' }}</span>
          </div>
          <div class="list-main-info-type">机构名称：{{ goodsOrg }}</div>
          <div class="list-main-info-type">类型：{{ type }}</div>
        </div>
      </div>
      <div class="list-bottom">
        <div class="list-bottom-status">
          <van-image
            class="list-bottom-status-icon"
            :src="status == 3 ? img3 : status == 4 ? img2 : img1"
          />
          <div
            class="list-bottom-status-text"
            :style="{
              color:
                status == 3 ? '#39CD36' : status == 4 ? '#666666' : '#0080FF'
            }"
          >
            {{ statusText }}
          </div>
        </div>
      </div>
    </div>
    <div class="sure">
      <van-button class="sure-btns" type="info" @click="btnTap"
        >再想想</van-button
      >
      <van-button class="sure-btn" type="info" @click="cancelOrder"
        >确认取消</van-button
      >
    </div>
  </div>
</template>

<script>
import { getLocalStorage } from '@utils'
import { Toast } from 'vant'
import { orderDetail, confirmRefuseOrder } from '@api/market/index'

export default {
  data() {
    return {
      img1: require('@/assets/sc-pic1.png'),
      img2: require('@/assets/失效状态@4x.png'),
      img3: require('@/assets/完成状态@4x.png'),
      statusText: '', // 状态
      goodsName: '', // 商品名
      img: '',
      iscoupons: '',
      price: 0, // 金额
      goodsOrg: '',
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {},
      type: '', // 类型
      couponId: ''
    }
  },
  mounted() {
    this.getOrderDetail()
  },
  methods: {
    getOrderDetail() {
      const params = {
        id: this.$route.query.id
      }
      orderDetail(params).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          let statusText = ''
          switch (data.orderStatus) {
            case 0:
              statusText = '待机构确认'
              break
            case 1:
              statusText = '待企业确认'
              break
            case 2:
              statusText = '待评价'
              break
            case 3:
              statusText = '已评价'
              break
            case 4:
              statusText = '已失效'
              break
          }
          this.statusText = statusText

          this.id = data.id
          this.goodsName = data.goodsName
          this.img = data.goodsUrl
          this.iscoupons = data.useCoupon
          this.goodsOrg = data.goodsOrg
          this.type = data.goodsType
          this.price = data.price
          this.couponsId = data.couponId
        } else {
          Toast(msg)
        }
      })
    },
    btnTap() {
      this.$router.go(-1)
    },
    // 取消订单
    cancelOrder() {
      const params = {
        id: this.id,
        entCouponId: this.couponId
      }
      confirmRefuseOrder(params).then(res => {
        const { msg, data } = res.data
        Toast(msg)
        this.btnTap()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.order-cancel {
  width: 100%;
  min-height: 100vh;
  background: #f7f7f7;
  padding-bottom: 80px;
  box-sizing: border-box;
  .notice {
    padding: 15px;
    background: #0080ff;
    display: flex;
    align-items: center;
    &-icon {
      width: 16px;
      height: 16px;
    }
    &-text {
      flex: 1;
      font-size: 14px;
      color: #fff;
      padding-left: 8px;
    }
  }
  .list {
    background: #fff;
    border-radius: 4px;
    padding-bottom: 15px;
    margin-top: 10px;
    &-title {
      font-size: 16px;
      padding: 10px 15px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-bottom: 1px solid #eee;
    }
    &-main {
      padding: 10px 15px;
      display: flex;
      align-items: center;
      &-imgwrap {
        position: relative;
        &-img {
          width: 90px;
          height: 80px;
        }
        &-tab {
          padding: 6px;
          background: #ff5c2c;
          font-size: 12px;
          color: #fff;
          position: absolute;
          top: 0;
          left: 0;
          border-bottom-right-radius: 10px;
        }
      }
      &-info {
        flex: 1;
        padding-left: 10px;
        margin-top: -6px;
        &-price {
          font-size: 14px;
          color: #999;
          span {
            font-size: 18px;
            font-weight: bold;
            color: #333;
            // color: #ff5c2c;
          }
        }
        &-type {
          font-size: 14px;
          color: #999;
          margin-top: 8px;
        }
      }
    }
    &-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px 0;
      &-status {
        height: 36px;
        flex: 1;
        display: flex;
        align-items: center;
        padding: 0 15px;
        // background: #fff9f5;
        border-radius: 6px;
        &-icon {
          width: 16px;
          height: 16px;
        }
        &-text {
          font-size: 14px;
          color: #ff6600;
          padding-left: 10px;
        }
      }
    }
  }
  .reminder {
    background-color: #fff;
    img {
      width: 25px;
      height: 25px;
      vertical-align: middle;
      margin-left: 15px;
    }
    b {
      color: rgba(0, 0, 0, 0.85);
      font-size: 17px;
      margin-left: 10px;
      vertical-align: middle;
    }
  }
  .order-explain {
    padding-top: 22px;
    background-color: #fff;
    padding-left: 15px;
    padding: 22px 15px 12px;

    > div {
      color: rgba(51, 51, 51, 100);
      font-size: 14px;
      padding-left: 36px;
      background: url('../../../assets/zj-pic1.png') no-repeat;
      background-size: 45px 21px;
      margin-bottom: 21px;
      span {
        display: inline-block;
        vertical-align: text-top;
        width: 304px;
        margin-top: 2px;
      }
    }
    > div:nth-child(2) {
      background: url('../../../assets/zj-pic2.png') no-repeat;
      background-size: 45px 20px;
    }
    > div:nth-child(3) {
      background: url('../../../assets/zj-pic3.png') no-repeat;
      background-size: 45px 21px;
    }
  }
  .sure {
    padding: 10px 15px;
    background: #fff;
    width: 100%;
    position: fixed;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    letter-spacing: 2px;
    &-btn {
      // flex: 1;
      border-radius: 6px;
      min-width: 48%;
    }
    &-btns {
      min-width: 48%;
      // flex: 1;
      border-radius: 6px;
      background: #e8f4ff;
      color: rgba(0, 128, 255, 0.9);
      border: none;
    }
  }
}
</style>
